/** French strings for the partners slice (namespace: partners.*). */
export const partnersFr = {
  title: "Groupe partenaire",
  loading: "Chargement…",
  retry: "Réessayer",
  loadError: "Une erreur est survenue lors du chargement. Veuillez réessayer.",
  actionFailed: "L'action n'a pas pu être complétée. Veuillez réessayer.",

  tabs: {
    groups: "Mes groupes",
    superUsers: "Partenaires régionaux",
  },

  accept: {
    heading: "Accepter l'invitation",
    body: "Vous avez été invité(e) à rejoindre l'Activateur. Acceptez l'invitation pour continuer.",
    accept: "Accepter l'invitation",
    accepting: "Acceptation…",
    success: "Invitation acceptée.",
    error: "Cette invitation n'a pas pu être acceptée.",
    done: "Tout est prêt. Vous pouvez retourner à votre tableau de bord.",
  },

  groups: {
    heading: "Groupes partenaires",
    subtitle: "Gérez vos groupes, leurs membres et leur bassin de licences.",
    newGroup: "Nouveau groupe",
    create: "Créer le groupe",
    creating: "Création…",
    cancel: "Annuler",
    empty: "Aucun groupe partenaire pour le moment.",
    emptyHint: "Créez votre premier groupe pour commencer à inviter des membres.",
    open: "Ouvrir",
    nameLabel: "Nom du groupe",
    namePlaceholder: "p. ex. Région de Montréal",
    maxLicensesLabel: "Licences maximales",
    maxLicensesHint: "Laisser vide pour aucune limite.",
    colName: "Nom",
    colCode: "Code partenaire",
    colMembers: "Membres",
    colLicenses: "Licences",
    colOwner: "Propriétaire",
    noCode: "—",
  },

  detail: {
    back: "Retour aux groupes",
    history: "Historique",
    settings: "Paramètres du groupe",
    partnerCode: "Code partenaire",
    owner: "Propriétaire",
    delete: "Supprimer le groupe",
    confirmDelete:
      "Supprimer définitivement ce groupe ? Cette action est irréversible.",
    deleting: "Suppression…",
    members: "Membres",
    licensePool: "Bassin de licences",
    licensePoolSummary: "{{used}} licences utilisées sur {{max}}",
    licensePoolUnlimited: "{{used}} licences utilisées (aucune limite)",
    poolThisGroup: "Licences du groupe",
    poolOwnerPool: "Licences totales (tous les groupes)",
    groupMembers: "Membres du groupe",
    poolUsedOfMax: "{{used}} / {{max}}",
    poolAvailable: "{{count}} disponibles",
    poolUnlimited: "{{used}} utilisées · illimité",
    inviteMember: "Inviter un membre",
    dangerZone: "Zone de danger",
    deleteWarning:
      "Supprimer définitivement ce groupe et toutes ses données. Cette action est irréversible.",
  },

  invitationEmail: {
    discard: "Vos modifications non enregistrées seront perdues. Continuer ?",
    help: "Voici le courriel que recevra la personne invitée. Vous pouvez le modifier avant de l'envoyer ; le bouton d'invitation est ajouté automatiquement sous votre message.",
    existingAccountNote:
      "Si cette adresse a déjà un compte Activateur, la personne recevra plutôt un avis l'invitant à accepter l'invitation dans l'application.",
    body: "Message",
    saveAsTemplate: "Enregistrer comme modèle",
    reset: "Rétablir le texte par défaut",
    saved: "Modèle enregistré pour ce groupe.",
    saveFailed: "Impossible d'enregistrer le courriel.",
    loading: "Chargement du courriel…",
    loadFailed: "Impossible de charger le courriel.",
  },
  members: {
    // Why a member no longer pays. Same words as the Django chips
    // (self_diagnostic.licensing.SUBSCRIPTION_STATE_LABELS).
    subscriptionState: {
      cancelled: "Résilié",
      expired: "Expiré",
    },
    empty: "Aucun membre actif pour le moment.",
    colName: "Membre",
    colEmail: "Courriel",
    colRole: "Rôle",
    colLicense: "Licence",
    hasLicense: "Sous licence",
    noLicense: "Aucune licence",
    externalLicense: "Licence externe",
    externalLicenseHint: "Détient une licence d'un autre groupe.",
    owner: "Propriétaire",
    grant: "Octroyer une licence",
    revokeLicense: "Révoquer la licence",
    revokeMember: "Retirer le membre",
    confirmRevokeMember: "Retirer {{name}} de ce groupe ?",
    working: "En cours…",
    roleMember: "Membre",
    roleLocalPartner: "Partenaire local",
    rolePartner: "Partenaire",
    linkResults: "Résultats",
    linkActionPlan: "Plan d'action",
    linkSelfAssessment: "Autoévaluation",
    noSharedData: "Aucune donnée partagée",
    consentNotGranted: "Consultation non accordée",
    manage: "Gérer",
    manageTitle: "Gérer · {{name}}",
    licenceLabel: "Licence",
    startedWarning:
      "Ce membre a commencé son autoévaluation — le retirer conserve ses données mais met fin à votre accès.",
    close: "Fermer",
  },

  memberData: {
    banner: "Consultation des données de {{name}}",
    readOnly: "Lecture seule — ce membre n'a pas accordé le consentement de modification.",
    back: "Retour au groupe",
    history: "Historique",
    viewLabel: "Données du membre",
    tabs: {
      diagnostic: "Autoévaluation",
      plan: "Plan d'action",
    },
  },

  invite: {
    heading: "Inviter une personne",
    emailLabel: "Adresse courriel",
    emailPlaceholder: "nom@exemple.com",
    roleLabel: "Rôle",
    roleMember: "Membre",
    roleLocalPartner: "Partenaire local",
    submit: "Envoyer l'invitation",
    sending: "Envoi…",
    sent: "Invitation envoyée à {{email}}.",
    confirmPromoteTitle: "Utilisateur existant",
    confirmPromoteBody:
      "Un compte existe déjà avec cette adresse courriel. Voulez-vous l'inviter à devenir partenaire local de votre groupe ? Il le deviendra s'il accepte l'invitation depuis son compte.",
    confirmPromote: "Envoyer l'invitation",
    promoteName: "Nom",
    promoteEmail: "Courriel",
    promoteEnterprise: "Entreprise",
    promoteAddress: "Adresse",
    promotePhone: "Téléphone",
    cancel: "Annuler",
    pending: "Invitations en attente",
    resend: "Renvoyer",
    resending: "Renvoi…",
    resent: "Invitation renvoyée.",
    cancelInvite: "Annuler",
    cancelling: "Annulation…",
    cancelled: "Invitation annulée.",
  },

  groupInvitations: {
    colEmail: "Courriel",
    colSent: "Envoyée le",
    colExpires: "Expire le",
    colStatus: "Statut",
    status: {
      pending: "En attente",
      expired: "Expirée",
      declined: "Refusée",
      licence_cap: "Licences épuisées",
      accepted: "Acceptée",
    },
    confirmCancel: "Confirmer l'annulation de cette invitation ?",
  },

  superUsers: {
    heading: "Partenaires régionaux",
    subtitle:
      "Invitez et gérez les partenaires régionaux et leurs bassins de licences.",
    adminOnly: "Seuls les administrateurs peuvent gérer les partenaires régionaux.",
    empty: "Aucun partenaire régional pour le moment.",
    colName: "Nom",
    colEmail: "Courriel",
    colMaxGroups: "Groupes max",
    colMaxLicenses: "Licences max/groupe",
    edit: "Modifier",
    invite: "Inviter un partenaire régional",
    unlimited: "Aucune limite",
    editHeading: "Paramètres du bassin — {{name}}",
    maxGroupsLabel: "Nombre maximal de groupes",
    maxLicensesLabel: "Licences maximales par groupe",
    discountTypeLabel: "Type de rabais",
    discountPercentage: "Pourcentage",
    discountFixed: "Montant fixe",
    discountValueLabel: "Valeur du rabais",
    discountDurationLabel: "Durée du rabais (années)",
    close: "Fermer",
  },

  localPartners: {
    heading: "Partenaires locaux",
    empty: "Aucun partenaire local pour le moment.",
    colGroups: "Groupe(s)",
    groupLicences: "Licences du groupe",
    editHeading: "Paramètres — {{name}}",
  },

  inviteSuperUser: {
    heading: "Inviter un partenaire régional",
    emailLabel: "Adresse courriel",
    submit: "Envoyer l'invitation",
    sending: "Envoi…",
    sent: "Invitation envoyée à {{email}}.",
    maxGroupsLabel: "Nombre maximal de groupes",
    maxLicensesLabel: "Licences maximales par groupe",
    groupNameLabel: "Nom du groupe initial (optionnel)",
    preGroupsLabel: "Groupes à pré-créer (optionnel)",
    preGroupsPlaceholder: "Un nom par ligne (ou séparés par des virgules)",
  },
  inviteLocalPartner: {
    heading: "Inviter un partenaire local",
    emailLabel: "Adresse courriel",
    submit: "Envoyer l'invitation",
    sending: "Envoi…",
    sent: "Invitation envoyée à {{email}}.",
  },
  invitations: {
    heading: "Invitations en attente",
    empty: "Aucune invitation en attente.",
    typeRegional: "Partenaire régional",
    typeLocal: "Partenaire local",
    resend: "Renvoyer",
    cancel: "Annuler",
  },
} as const;

/** French strings for the consent screens (namespace: consents.*). */
export const consentsFr = {
  title: "Consentement",
  loading: "Chargement…",
  retry: "Réessayer",

  modeLabel: "Vue du consentement",
  mode: {
    member: "Mon consentement",
    partner: "Consentement des membres",
  },

  member: {
    heading:
      "Consentement au partage de mes informations contenues dans l'Activateur",
    // Named group(s) interpolated as {{groups}}; singular/plural on {{count}} —
    // parity with Django's blocktrans in member-consent.html (K-4).
    intro_one:
      "Vous faites partie du groupe {{groups}} vous donnant un accès privilégié à l'Activateur. Ce partenaire a accès aux informations de votre profil (excluant les informations de paiement) et à votre progression dans l'Activateur.",
    intro_other:
      "Vous faites partie des groupes {{groups}} vous donnant un accès privilégié à l'Activateur. Ces partenaires ont accès aux informations de votre profil (excluant les informations de paiement) et à votre progression dans l'Activateur.",
    introOptional:
      "Optionnel : vous pouvez donner des accès supplémentaires à {{groups}}. Pour ce faire, veuillez cocher parmi la liste suivante :",
    and: "et",
    noProfile:
      "Vous n'avez pas encore de profil d'entreprise. Complétez d'abord l'étape d'identification de votre autoévaluation.",
    diagnostic:
      "Permettre la consultation de l'information contenue dans l'autoévaluation, le plan d'action et la communication des réalisations",
    edit:
      "Permettre l'édition de l'information contenue dans l'autoévaluation, le plan d'action et la communication des réalisations",
    granted: "Accordé",
    notGranted: "Non accordé",
    continue: "Continuer",
    error: "Une erreur est survenue. Veuillez réessayer.",
  },

  partner: {
    heading: "État du consentement des membres",
    intro:
      "Consultez ce qu'un membre a accepté de partager, à partir de son profil d'entreprise.",
    profileIdLabel: "Identifiant du profil d'entreprise",
    profileIdPlaceholder: "00000000-0000-0000-0000-000000000000",
    lookup: "Consulter",
    looking: "Consultation…",
    notFound: "Aucun profil trouvé pour cet identifiant, ou accès refusé.",
    enterprise: "Entreprise",
    viewConsent: "Vous pouvez consulter l'autoévaluation de ce membre",
    viewConsentYes: "Oui",
    viewConsentNo: "Non",
    progress: "Progrès partagé",
    diagnostic: "Autoévaluation partagée",
    edit: "Modification autorisée",
    yes: "Oui",
    no: "Non",
  },
} as const;

/** Strings for the admin promo-code screen (namespace: promoCodes.*). */
export const promoCodesFr = {
  title: "Codes promotionnels",
  intro:
    "Un code promotionnel lié à un groupe partenaire rattache automatiquement l'entreprise à ce groupe et consomme une licence, comme le ferait un code partenaire. Un code non lié accorde un rabais sans être rattaché à personne : les licences qu'il consomme restent introuvables.",
  search: "Recherche",
  searchPlaceholder: "Code ou groupe",
  state: "État",
  stateAll: "Tous les états",
  stateBound: "Liés à un groupe",
  stateUnbound: "Non liés",
  group: "Groupe",
  groupAll: "Tous les groupes",
  groupSearch: "Rechercher un groupe…",
  noGroupMatch: "Aucun groupe ne correspond.",
  reset: "Réinitialiser",
  loading: "Chargement…",
  loadError: "Impossible de charger les codes.",
  empty: "Aucun résultat",
  colCode: "Code",
  colDiscount: "Rabais",
  colUses: "Utilisations",
  colState: "État",
  colGroup: "Groupe partenaire",
  colActions: "Actions",
  bound: "Lié",
  unbound: "Non lié",
  bind: "Lier à un groupe",
  bindTitle: "Lier un code à un groupe",
  bindHint:
    "Une fois lié, ce code rattachera l'entreprise au groupe choisi et lui appliquera le rabais de ce groupe.",
  bindSucceeded: "Le code « {{code}} » est maintenant lié.",
  bindFailed: "Impossible de lier ce code.",
  chooseGroup: "Choisir un groupe",
  cancel: "Annuler",
  backfill: "Reprise",
  backfillTitle: "Reprise des membres",
  scanning: "Analyse des factures Stripe… ({{scanned}} analysées)",
  scanned: "{{count}} factures analysées.",
  scanFailed: "Analyse impossible.",
  confirmFailed: "La reprise a échoué.",
  noCandidates: "Aucun membre à reprendre pour ce groupe.",
  colMember: "Membre",
  colSubscription: "Abonnement",
  colLicences: "Licences",
  overCap: "dépassement",
  // The preview's subscription column — the member list's words, plus a
  // subscription still running. Keyed like licensing.preview_subscription_state.
  subscriptionState: {
    cancelled: "Résilié",
    expired: "Expiré",
    active: "Actif",
  },
  overCapWarning:
    "Le groupe dépasse maintenant sa limite de licences. C'est voulu : ces licences ont réellement été consommées.",
  addSelected: "Ajouter {{count}} membre(s)",
  joined: "{{count}} membre(s) ajouté(s).",
  bucketSkipped: "Déjà dans un autre groupe — laissés tels quels",
  bucketUnresolved: "Codes liés que Stripe ne connaît pas",
  alreadyIn: "déjà dans « {{group}} »",
  neverSubscribed:
    "Une entreprise jamais abonnée ne laisse aucune facture et ne peut pas être retrouvée ici.",
} as const;
